import React from "react";
import { connect } from "react-redux";
import { Col } from "react-bootstrap";
import PropTypes from "prop-types";

import Table from "../../../layout/table";
import { initialState } from "../../../layout/table/helpers";
import ConditionalButton from "../../../layout/conditional-button";

import { send as pageInfo, loading } from "../../../actions/page";
import { withNavigation } from "../../../utils/wrapper";

// TODO: create this action to call your PayPeriod endpoint
// e.g. actions/payperiod.js -> exports.search or exports.list
import { search as searchPayPeriods } from "../../../actions/pay.periods";

class PayPeriods extends React.Component {
    constructor(props) {
        super(props);
        this.state = initialState({ order: "startsOn", size: 25 });
        this.props.loading(true);
    }

    componentDidMount = () => {
        setTimeout(async () => {
            await this.loadData();
        }, 30);
    };

    loadData = async () => {
        this.props.loading(true);

        const { page, size, order, direction, search } = this.state;

        // Expecting your action to return something like:
        // { items: [...], count: N, success: true }
        const result = await this.props.searchPayPeriods({
            search,
            page,
            size,
            order,
            direction,
        });

        const count = Number(result?.count ?? 0);
        const pages = size > 0 ? Math.ceil(count / Number(size)) : 0;

        this.setState({
            data: result.items,
            pages,
        });

        await this.props.pageInfo({ title: "Pay Periods", breadcrumb: `Pay Periods` });
        this.props.loading(false);
    };

    // --- table headers
    get headers() {
        return [
            {
                header: "Label",
                sortable: true,
                source: "label",
                className: "text-muted text-small text-uppercase w-25",
                onFormat: this.onLinkFormat,
            },
            {
                header: "Start",
                sortable: true,
                source: "startsOn",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onDateFormat,
            },
            {
                header: "End",
                sortable: true,
                source: "endsOn",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onDateFormat,
            },
            {
                header: "Pay Date",
                sortable: true,
                source: "payDate",
                className: "text-muted text-small text-uppercase w-20",
                onFormat: this.onDateFormat,
            },
            {
                header: "Status",
                sortable: true,
                source: "status",
                className: "text-muted text-small text-uppercase w-15",
                onFormat: this.onStatusFormat,
            },
        ];
    }

    // --- formatters
    onDateFormat = (e) => {
        if (!e) return "";
        // If backend returns DATEONLY string, this will display it as-is; if it returns ISO, slice.
        const s = String(e);
        return s.length >= 10 ? s.slice(0, 10) : s;
    };

    onStatusFormat = (e) => {
        if (!e) return "";
        return String(e).toUpperCase();
    };

    onLinkFormat = (e, row) => {
        const text = e || row?.uuid || "";
        return `<a href="/dashboard/accounting/payperiods/${row["uuid"]}">${text}</a>`;
    };

    // --- table handlers (wire to your Table’s expectations)
    onNewClick = () => {
        this.props.navigate("add");
    };

    onSearch = async (search) => {
        this.setState({ search: search ?? "", page: 0 }, this.loadData);
    };

    onSize = async (size) => {
        this.setState({ size: Number(size), page: 0 }, this.loadData);
    };

    onPageChange = async (page) => {
        this.setState({ page: Number(page) }, this.loadData);
    };

    onColumnClick = async (header) => {
        if (!header?.sortable) return;

        const order = header.source;
        let direction = this.state.direction;

        // toggle direction if clicking same column, otherwise default DESC
        if (this.state.order === order) direction = direction === "ASC" ? "DESC" : "ASC";
        else direction = "DESC";

        this.setState({ order, direction, page: 0 }, this.loadData);
    };

    render() {
        return (
            <>
                <Col md="8" className="float-right text-end">
                    <ConditionalButton
                        enabledVariant="outline-primary"
                        tooltip="Create new pay period"
                        display
                        enabled={true}
                        onEnabledClick={this.onNewClick}
                        icon="flash"
                    >
                        New
                    </ConditionalButton>
                </Col>

                <Col xs="12">
                    <Table
                        headers={this.headers}
                        page={this.state.data}
                        size={this.state.size}
                        index={this.state.page}
                        pages={this.state.pages}
                        onColumnClick={this.onColumnClick}
                        onPageChange={this.onPageChange}
                        onSearch={this.onSearch}
                        onSize={this.onSize}
                        searchable={true}
                        sizable={true}
                    />
                </Col>
            </>
        );
    }
}

PayPeriods.propTypes = {
    auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default withNavigation(
    connect(mapStateToProps, { searchPayPeriods, loading, pageInfo })(PayPeriods)
);
